export interface CurrentSubscription {
	providerSubscriptionId?: string;
	plan: string;
	billingCycle: string;
	currentPeriodEnd: string | null;
	cancelAtPeriodEnd: boolean;
}

interface CurrentSubscriptionApi {
	getCurrentSubscription?: (options?: { force?: boolean }) => Promise<{ subscription: CurrentSubscription | null }>;
}

/** Invoke the optional subscription endpoint without detaching it from its transport client. */
export function readCurrentSubscription(
	api: CurrentSubscriptionApi | undefined,
	options: { force?: boolean } = {},
): Promise<{ subscription: CurrentSubscription | null }> | null {
	const method = api?.getCurrentSubscription;
	return typeof method === 'function' ? method.call(api, options) : null;
}
